import { Notification } from './actions';

export interface NotificationsState {
  pending: boolean;
  notifications: Notification[] | null;
  error?: string;
}

export const defaultNotificationsState = {
  pending: false,
  notifications: null,
  error: null,
};
